<template>
    <div class="competences-wrapper">
        <h3>Необходимо прокачать</h3>
        <Tabs
            class="competences-tabs"
            :headers="tabs.map(v => v.title)"
            :activeTab="activeTab"
            :full="false"
            :outline="true"
            @change="setTab"
        />
        <div class="tab">
            <component
                :is="tabs[activeTab].component"
            />
        </div>
    </div>
</template>

<script>

import Tabs from '../components/Tabs';
import HardCompetencesWrapper from './components/hard-competences/HardCompetencesWrapper';
import SoftCompetencesWrapper from './components/soft-competences/SoftCompetencesWrapper';

export default {
    name: 'Competences',
    components: {
        Tabs,
        HardCompetencesWrapper,
        SoftCompetencesWrapper,
    },

    data: ()=>({
        activeTab: 0,
        tabs: [
            {
                title: 'Компетенции',
                component: 'SoftCompetencesWrapper',
            },
            {
                title: 'Профессиональные навыки',
                component: 'HardCompetencesWrapper',
            },
        ],
    }),
    methods: {
        setTab(index){
            this.activeTab = index;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/styles/rem";

    .competences-wrapper{
        background: white;
        border: 1px solid #D2D5D9;
        width: 100%;
        border-top: none;

        @include on-md {
            border-top: 1px solid #D2D5D9;
        }

        h3{
            font-style: normal;
            font-weight: 600;
            font-size: 22px;
            line-height: 30px;
            padding-left: 21px;
        }
        .tab{
            width: 100%;
        }
        .tabs {
            height: 100px;
        }
    }
</style>